import React from 'react';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { ChevronDownIcon, DocumentTextIcon, PlayIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import ProgressBar from '../../components/common/ProgressBar';
import { Link } from 'react-router-dom';

function ExamCard({ exam, onStartQuiz }) {
    return (
        <div className="card bg-base-200 shadow-lg ring-1 ring-base-content/5">
            <Disclosure>
                {({ open }) => (
                    <>
                        <div className="card-body p-4">
                            <DisclosureButton className="w-full">
                                <div className="grid grid-cols-12 gap-4 items-center">
                                    {/* Icon & Title Group */}
                                    <div className="col-span-12 sm:col-span-5">
                                        <div className="flex items-center gap-3">
                                            <div className="rounded-lg bg-primary/20 p-3 ring-1 ring-primary/30">
                                                <DocumentTextIcon className="w-6 h-6 text-primary" />
                                            </div>
                                            <div className="flex flex-col items-start">
                                                <h2 className="text-lg font-bold text-base-content">
                                                    {exam.title}
                                                </h2>
                                                <div className="text-xs text-base-content/70">
                                                    {exam.total_questions} Fragen
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Progress Bar */}
                                    <div className="col-span-11 sm:col-span-6">
                                        <ProgressBar 
                                            green={exam.green_questions}
                                            yellow={exam.yellow_questions}
                                            red={exam.red_questions}
                                            white={exam.white_questions}
                                            total={exam.total_questions}
                                        />
                                    </div>

                                    {/* Chevron */}
                                    <div className="col-span-1 flex justify-end">
                                        <ChevronDownIcon
                                            className={`w-5 h-5 text-base-content/50 transition-all duration-300
                                                ${open ? 'transform rotate-180' : ''}`}
                                        />
                                    </div>
                                </div>
                            </DisclosureButton>

                            <DisclosurePanel>
                                <div className="mt-6">
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                                        {exam.subcategories.map((subcategory) => (
                                            <div key={subcategory.id} className="card bg-base-100 shadow-md">
                                                <div className="card-body p-4">
                                                    <div className="flex flex-col h-full">
                                                        <h4 className="font-medium text-base-content mb-4">
                                                            {subcategory.title}
                                                        </h4>

                                                        <div className="mb-4">
                                                            <ProgressBar 
                                                                green={subcategory.green_questions}
                                                                yellow={subcategory.yellow_questions}
                                                                red={subcategory.red_questions}
                                                                white={subcategory.white_questions}
                                                                total={subcategory.total_questions}
                                                                size="sm"
                                                            />
                                                        </div>

                                                        <div className="mt-auto flex gap-2">
                                                            <Link
                                                                to={`/alle-fragen?examPart=${subcategory.id}`}
                                                                className="btn btn-secondary btn-sm flex-1"
                                                                title={`Alle ${subcategory.total_questions} Fragen aus ${subcategory.title} anzeigen`}
                                                            >
                                                                <QuestionMarkCircleIcon className="w-4 h-4" />
                                                                {subcategory.total_questions} Fragen
                                                            </Link>
                                                            <button 
                                                                onClick={() => onStartQuiz(subcategory.id)}
                                                                className="btn btn-primary btn-sm flex-1"
                                                            >
                                                                <PlayIcon className="w-4 h-4" />
                                                                Starten
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </DisclosurePanel>
                        </div>
                    </>
                )}
            </Disclosure>
        </div>
    );
}

export default ExamCard; 